import { render, staticRenderFns } from "./ParcMenuItem.vue?vue&type=template&id=066aed43&"
import script from "./ParcMenuItem.vue?vue&type=script&lang=js&"
export * from "./ParcMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ParcMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports